import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'premium'>('premium');
  return <section id="pricing" className="py-20 px-4 bg-white scroll-mt-10" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        <div className="text-center mb-12" data-id="element-155">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-156">
            🛒 ELEGÍ TU PLAN Y EMPEZÁ HOY
          </h2>
          <p className="text-xl text-gray-600 italic" data-id="element-157">
            Seleccioná la opción que más te conviene:
          </p>
        </div>

        <div className="space-y-6 mb-12" data-id="element-158">
          {/* Plan 1: Basic */}
          <div onClick={() => setSelectedPlan('basic')} className={`relative border-2 rounded-2xl p-6 md:p-8 cursor-pointer transition-all duration-300 ${selectedPlan === 'basic' ? 'border-green-500 bg-green-50/30 shadow-lg scale-[1.02]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-159">
            <div className="flex items-start gap-4" data-id="element-160">
              <div className="mt-1 flex-shrink-0" data-id="element-161">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'basic' ? 'border-green-500' : 'border-gray-300'}`} data-id="element-162">
                  {selectedPlan === 'basic' && <div className="w-3 h-3 bg-green-500 rounded-full" data-id="element-163" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-164">
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-165">
                  📘 MEGAPACK COMPLETO
                </h3>
                <p className="text-gray-600 font-medium mb-6" data-id="element-166">
                  6 Tomos + 4 Bonos
                </p>

                <ul className="space-y-3 mb-8" data-id="element-167">
                  <li className="flex items-start gap-2" data-id="element-168">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-169" />
                    <span className="text-gray-700" data-id="element-170">
                      Los 6 tomos del Método CALMA®
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-171">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-172" />
                    <span className="text-gray-700" data-id="element-173">4 Bonos exclusivos</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-174">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-175" />
                    <span className="text-gray-700" data-id="element-176">
                      Acceso inmediato en PDF
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-177">
                    <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-178" />
                    <span className="text-gray-700" data-id="element-179">
                      Garantía 7 días sin riesgo
                    </span>
                  </li>
                </ul>

                <div className="flex flex-col items-start" data-id="element-180">
                  <span className="text-gray-400 line-through text-lg font-medium" data-id="element-181">
                    $126.000
                  </span>
                  <span className="text-4xl md:text-5xl font-black text-gray-900" data-id="element-182">
                    $19.990
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Plan 2: Premium (Default) */}
          <div onClick={() => setSelectedPlan('premium')} className={`relative border-4 rounded-2xl p-6 md:p-8 cursor-pointer transition-all duration-300 ${selectedPlan === 'premium' ? 'border-yellow-500 bg-slate-900 shadow-2xl scale-[1.02]' : 'border-slate-700 bg-slate-800 hover:border-slate-600'}`} data-id="element-183">
            {/* Badges */}
            <div className="absolute -top-5 left-0 right-0 flex justify-center gap-2 px-4 flex-wrap" data-id="element-184">
              <span className="bg-yellow-400 text-yellow-900 text-xs md:text-sm font-black px-4 py-1.5 rounded-full shadow-md flex items-center gap-1 uppercase tracking-wider" data-id="element-185">
                ⭐ MÁS ELEGIDO
              </span>
              <span className="bg-red-500 text-white text-xs md:text-sm font-black px-4 py-1.5 rounded-full shadow-md flex items-center gap-1 uppercase tracking-wider" data-id="element-186">
                🔥 AHORRÁS $150.010
              </span>
            </div>

            <div className="flex items-start gap-4 mt-4" data-id="element-187">
              <div className="mt-2 flex-shrink-0" data-id="element-188">
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'premium' ? 'border-yellow-400' : 'border-slate-500'}`} data-id="element-189">
                  {selectedPlan === 'premium' && <div className="w-3 h-3 bg-yellow-400 rounded-full" data-id="element-190" />}
                </div>
              </div>

              <div className="flex-1" data-id="element-191">
                <h3 className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-192">
                  🏆 MEGAPACK PREMIUM + ACELERADOR
                </h3>
                <p className="text-yellow-400 font-bold mb-6 text-lg" data-id="element-193">
                  6 Tomos + 4 Bonos + El Acelerador 21 Días + Botiquín de
                  Emergencia Emocional
                </p>

                <ul className="space-y-4 mb-8" data-id="element-194">
                  <li className="flex items-start gap-3" data-id="element-195">
                    <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-196" />
                    <span className="text-slate-200 text-lg" data-id="element-197">
                      Los 6 tomos del Método CALMA®
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-198">
                    <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-199" />
                    <span className="text-slate-200 text-lg" data-id="element-200">
                      4 Bonos exclusivos
                    </span>
                  </li>
                  <li className="flex items-start gap-3 bg-slate-800/50 p-4 rounded-xl border border-slate-700" data-id="element-201">
                    <CheckIcon className="w-6 h-6 text-yellow-400 flex-shrink-0" data-id="element-202" />
                    <div data-id="element-203">
                      <span className="text-yellow-400 font-bold text-lg block mb-1" data-id="element-204">
                        ⚡ EL ACELERADOR 21 DÍAS
                      </span>
                      <span className="text-slate-400 text-sm italic" data-id="element-205">
                        (Implementación guiada paso a paso — convertí cada
                        herramienta en hábito real en 3 semanas)
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3 bg-gradient-to-r from-red-900/40 to-slate-800/50 p-4 rounded-xl border border-red-500/40" data-id="element-206">
                    <CheckIcon className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-207" />
                    <div data-id="element-208">
                      <div className="flex items-center gap-2 flex-wrap mb-1" data-id="element-209">
                        <span className="text-red-400 font-bold text-lg" data-id="element-210">
                          🚑 BOTIQUÍN DE EMERGENCIA EMOCIONAL
                        </span>
                        <span className="bg-red-500 text-white text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-211">
                          EXCLUSIVO PREMIUM
                        </span>
                      </div>
                      <span className="text-slate-400 text-sm italic" data-id="element-212">
                        (50 tarjetas de rescate rápido para esos momentos donde
                        necesitás una solución en 10 segundos — sin gritar)
                      </span>
                      <span className="text-red-400/80 text-xs block mt-1 font-bold" data-id="element-213">
                        Valor real:{' '}
                        <span className="line-through" data-id="element-214">$19.000</span> — INCLUIDO
                        GRATIS
                      </span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-215">
                    <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-216" />
                    <span className="text-slate-200 text-lg" data-id="element-217">
                      Acceso inmediato en PDF
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-218">
                    <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-219" />
                    <span className="text-slate-200 text-lg" data-id="element-220">
                      Garantía 7 días sin riesgo
                    </span>
                  </li>
                </ul>

                <div className="flex flex-col items-start bg-slate-950/50 p-4 rounded-xl inline-block" data-id="element-221">
                  <span className="text-slate-400 line-through text-xl font-medium" data-id="element-222">
                    $180.000
                  </span>
                  <span className="text-5xl md:text-6xl font-black text-white drop-shadow-lg" data-id="element-223">
                    $29.990
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Comparison Note */}
        <div className="bg-blue-50 border-l-4 border-blue-500 p-6 md:p-8 rounded-r-xl mb-12 shadow-sm" data-id="element-224">
          <h4 className="text-xl font-bold text-blue-900 mb-3 flex items-center gap-2" data-id="element-225">
            🤔 ¿Cuál elegir?
          </h4>
          <p className="text-blue-800 text-lg leading-relaxed mb-4" data-id="element-226">
            Por solo <strong data-id="element-227">$10.000 más</strong> recibís{' '}
            <strong data-id="element-228">El Acelerador 21 Días</strong> — el programa que te lleva de
            la mano día a día para que el método se convierta en tu nueva forma
            de criar — <strong data-id="element-229">MÁS</strong> el{' '}
            <strong data-id="element-230">Botiquín de Emergencia Emocional</strong> con 50 tarjetas de
            rescate rápido para los momentos más difíciles.
          </p>
          <p className="text-blue-900 font-black text-lg bg-blue-200/50 inline-block px-3 py-1 rounded" data-id="element-231">
            La mayoría de las mamás elige esta opción.
          </p>
        </div>

        <div className="mt-8" data-id="element-232">
          <CTAButton subtext="Hacé clic · Elegí tu plan · Acceso inmediato" data-id="element-233" />
        </div>
      </div>
    </section>;
}